import React, { memo, useEffect } from 'react';
import { Stack, Typography, Rating } from 'investira.react.components';
const QuestaoRating = memo(props => {
  const {
    rating,
    name = 'rating-hover',
    precision = 1,
    max = 4,
    readOnly,
    onChange
  } = props;
  const [value, setValue] = React.useState(0);
  const labels = {
    1: 'Ruim',
    2: 'Regular',
    3: 'Bom',
    4: 'Ótimo',
    5: 'Excelente'
  };
  function getLabelText(value) {
    return `${value} Estrela${value !== 1 ? 's' : ''}, ${labels[value]}`;
  }
  useEffect(() => {
    setValue(rating);
  }, [rating]);
  return <Stack direction="row" alignItems="center" py={1} gap={2} sx={{
    pointerEvents: 'auto'
  }} onClick={e => {
    e.stopPropagation();
  }} onMouseDown={e => {
    e.stopPropagation();
  }} onMouseUp={e => {
    e.stopPropagation();
  }} onDoubleClick={e => {
    e.stopPropagation();
  }}>
      <Typography variant="caption" color="textSecondary">
        Avaliação
      </Typography>
      <Rating readOnly={readOnly} name={name} value={value} precision={precision} getLabelText={getLabelText} max={max} onChange={(e, newValue) => {
      e.stopPropagation();
      e.preventDefault();
      setValue(newValue ?? null);
      onChange && onChange(newValue ?? null);
    }} onChangeActive={(e, newHover) => {
      e.stopPropagation();
      e.preventDefault();
    }} />
      {/* <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 600 }}>
        {value !== null && <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : value]}</Box>}
       </Typography> */}
    </Stack>;
});
export default QuestaoRating;
